
import { useLayoutEffect } from 'react';
import { gsap } from 'gsap';
import Translatable from '../translatable_text/Translatable';

type Props = {
  service: any
}
function Header({service}: Props) {  

  useLayoutEffect(() => {
    const tl = gsap.timeline();
    tl.fromTo('.header', { y: 200 }, { y: 0 }, '+=0.1');
    tl.fromTo(
      '.header .container',
      { opacity: 0, translateY: 40 },
      { opacity: 1, translateY: 0 },
      '-=0'
    );

    // Cleanup function
    return () => {
      tl.kill();
    }
  }, []);
  
  
  return (
    <div
      className="header page-header bg-img section-padding"
      data-background="/light/assets/imgs/header/b5.jpg"
      data-overlay-dark="9"
    >
      <div className="container pt-100">
        <div className="text-center">
          <h1>
            <Translatable>
              {service?.title}
            </Translatable>
          </h1>
          <div className="mt-15">
            <a href="/" aria-label='home button'>
              <Translatable>
                Home
              </Translatable>
            </a>
            <span className="padding-rl-20">|</span>
            <a href="/services" aria-label='services page button'>
              <Translatable>
                Services
              </Translatable>
            </a>
            <span className="padding-rl-20">|</span>
            <span className="main-color">
                <Translatable>
                  {service?.title}
                </Translatable>
              </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
